<template>
    <layouts-header></layouts-header>
    <layouts-sidebar></layouts-sidebar>
  
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- Page Header -->
            <page-header :title="title" />
            <!-- /Page Header -->
  
            <div class="card main-card">
              <div class="card-body">
                <!-- Search -->
                <div class="search-section">
                  <div class="row">
                    <div class="col-md-5 col-sm-4">
                      <div class="form-wrap icon-form">
                        <span class="form-icon"><i class="ti ti-search"></i></span>
                        <input type="text" class="form-control" placeholder="Search by Number or Title" v-model="searchQuery"
                          @input="searchActivity(1)" />
                      </div>
                    </div>
                    <div class="col-md-7 col-sm-8">
                      <div class="export-list text-sm-end">
                        <ul>
                          <!-- <li>
                              <select v-model="selectedFilter" class="form-select" @change="applyFilter">
                                <option v-for="item in filterOptions" :key="item.value" :value="item.value">
                                  {{ item.text }}
                                </option>
                              </select>
                            </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Search -->
  
                <!-- Activity List -->
                <div class="table-responsive custom-table">
                  <support-table ref="caseTable" :searchQuery="searchQuery" :filters="appliedFilters"
                    ></support-table>
                </div>
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <div class="datatable-length"></div>
                  </div>
                  <div class="col-md-6">
                    <div class="datatable-paginate"></div>
                  </div>
                </div>
                <!-- /Activity List -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, onMounted } from 'vue';
  import apiClient from '@/axios';
  
  export default defineComponent({
    name: 'CasesComponent',
    components: {},
    data() {
      return {
        title: "Support Tickets",
        searchQuery: '',
      };
    },
    setup(props, { expose }) {
      // const filterOptions = ref([]);
      // const selectedFilter = ref('all');
      const appliedFilters = ref({
        timeFrame: 'all'
      });
  
      const caseTable = ref()
  
      // const fetchFilters = async () => {
      //   try {
      //     const response = await apiClient.get('/dropdown/options/time_frame');
      //     if (response.status) {
      //       filterOptions.value = response.data;
      //     }
      //   } catch (error) {
      //     console.error('Error fetching time frame:', error);
      //   }
      // };
  
      const searchActivity = async (page=1) => {
         if(caseTable.value){
          caseTable.value.fetchCases(page)
         }
      };
  
      // const applyFilter = () => {
      //   appliedFilters.value.timeFrame = selectedFilter.value;
      //   searchActivity(); // Trigger the API call in the child component
      // };
  
      onMounted(() => {
        // fetchFilters();
      });
  
      return {
        // filterOptions,
        // selectedFilter,
        appliedFilters,
        // fetchFilters,
        // applyFilter,
        searchActivity,
        caseTable
      };
    }
  });
  </script>